// extracted by mini-css-extract-plugin
export default {"action":"style_action__uSb+S","container":"style_container__TAeta","disabled":"style_disabled__1-2LF","icon":"style_icon__S6GFp","label":"style_label__-VOdt"};